/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartArea100 = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M2 2v20.2h20V2zm18 18.2H4V17l4 2.4 7.9-4.9 4.1 3.3zm0-5.1L16.1 12 8 17.1l-4-2.4V10l4 2.4 7.9-4.9 4.1 3.3zm0-7L16.1 5 8 10.1 4 7.7V4h16z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgChartArea100 as ChartArea100 };
